import BillingsOrderTaxiRailyRecalculateRequest, {
  BillingsOrderTaxiRailyRecalculateRequestBillingNode,
} from "../../../../../api/raily/billings/order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate.request";
import BillingsOrderTaxiRailyRecalculateParams, {
  BillingsOrderTaxiRailyRecalculateParamsBillingNode,
} from "./billings-order-taxi-raily-recalculate-params";

const createBillingNode = (
  node: BillingsOrderTaxiRailyRecalculateParamsBillingNode,
): BillingsOrderTaxiRailyRecalculateRequestBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderTaxiRailyRecalculateParamsBillingNode[],
): BillingsOrderTaxiRailyRecalculateRequestBillingNode[] => {
  return nodes.map(createBillingNode);
};

const create = (
  params: BillingsOrderTaxiRailyRecalculateParams,
): BillingsOrderTaxiRailyRecalculateRequest => {
  return {
    billingNodes: createBillingNodes(params.billingNodes),
    billingType: params.billingType,
    discount: params.discount,
    orderId: params.orderId,
  };
};

const BillingsOrderTaxiRailyRecalculateParamsFactory = {
  create,
};

export default BillingsOrderTaxiRailyRecalculateParamsFactory;
